import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from "react-alert";
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import TablePagination from '@material-ui/core/TablePagination';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },

}));

const screenCode = 'DENOMINATIONREPORT';

export default function DenominationReport(props) {
  const [title, setTitle] = useState("Denomination Report");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routes, setRoutes] = useState();
  const [denominationdetails, setDenominationdetails] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    year: '',
    month: ''
  });
  const [denominationCropData, setDenominationCropData] = useState([]);
  const [prevTotalAmount, setPrevTotalAmount] = useState(0);
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    monthName: '',
    factoryName: "0",
    routeName: "0",
    groupName: '0',
  })
  const [csvHeaders, SetCsvHeaders] = useState([])
  const [cashCountList, setCashCountList] = useState([]);
  const [coinTotal, setCoinTotal] = useState([]);
  const [remainingValueTotal, setRemainingValueTotal] = useState(0);
  const [lastBalancePaymentRunDate, setLastBalancePaymentRunDate] = useState();
  const cash = ['5000', '1000', '500', '100', '50', '20'];
  const columnTitles = ['Reg No', 'Supplier Name', 'Amount(Rs)', ...cash, 'Remaining(Rs)'];
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [limit, setLimit] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    trackPromise(
      getPermission());
    trackPromise(
      getGroupsForDropdown());
  }, []);

  useEffect(() => {
    if (denominationdetails.groupID != 0) {
      trackPromise(
        getFactoriesForDropdown());
    }
  }, [denominationdetails.groupID]);

  useEffect(() => {
    if (denominationdetails.factoryID != 0)
      trackPromise(
        getRoutesByFactoryID());
    trackPromise(
      GetLastBalancePaymentExecutionDetails());
  }, [denominationdetails.factoryID]);

  useEffect(() => {
    setCashCountList([]);
  }, [denominationdetails.routeID, denominationdetails.groupID, denominationdetails.factoryID]);

  useEffect(() => {
    setCashCountList([]);
  }, [denominationdetails.month]);

  useEffect(() => {
    setSelectedDate(lastBalancePaymentRunDate);
  }, [lastBalancePaymentRunDate]);

  useEffect(() => {
    setDenominationdetails((prev) => ({
      ...prev,
      routeID: 0
    }))
  }, [denominationdetails.groupID, denominationdetails.factoryID])

  useEffect(() => {
      setCashCountList([])
  },[denominationdetails.month, denominationdetails.year])

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDENOMINATIONREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setDenominationdetails({
      ...denominationdetails,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(denominationdetails.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routeList = await services.getRoutesForDropDown(denominationdetails.factoryID);
    setRoutes(routeList);
  }

  async function GetDenominationDetails() {
    let totalAmount = 0;

    const denominationData = await GetDenominationDetailsList();

    if (denominationData.statusCode == "Success" && denominationData.data != null) {
      setDenominationCropData(denominationData.data);
      calculateCashCount(denominationData.data, cash)
      denominationData.data.forEach(x => {
        totalAmount = totalAmount + parseInt(x.amount);
      });
      setPrevTotalAmount(totalAmount);
      createDataForExcel(denominationData.data);

      if (denominationData.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(denominationData.message);

    }
  }

  async function GetDenominationDetailsList() {
    let model = {
      groupID: parseInt(denominationdetails.groupID),
      factoryID: parseInt(denominationdetails.factoryID),
      routeID: parseInt(denominationdetails.routeID),
      applicableMonth: (selectedDate.getMonth() + 1).toString().padStart(2, "0"),
      applicableYear: selectedDate.getFullYear().toString()
    };
    getSelectedDropdownValuesForReport(model);

    const denominationData = await services.GetDenominationReportDetails(model);
    return denominationData;
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setDenominationdetails({
      ...denominationdetails,
      [e.target.name]: value
    });
    setDenominationCropData([]);
  }

  function handleDateChange(date) {
    let monthNames = ["JAN", "FEB", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUG", "SEPT", "OCT", "NOV", "DEC"];
    var month = date.getUTCMonth() + 1;
    var year = date.getUTCFullYear();
    var currentmonth = moment().format('MM');
    let monthName = monthNames[month + 1];
    setSelectedSearchValues({
      ...selectedSearchValues,
      monthName: monthName
    })
    setDenominationdetails({
      ...denominationdetails,
      month: month,
      year: year
    });

    if (selectedDate != null) {

      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)
      }
    } else {
      setSelectedDate(date)
    }
    setDenominationCropData([]);
  }

  async function createDataForExcel(array) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          'Reg No': x && x.registrationNumber,
          'Supplier Name': x && x.supplierName,
          'Amount(Rs)': x && x.amount && x.amount,
          'FiveThousands(5000)': x && x.cashCount && x.cashCount[0] && x.cashCount[0].coinCount,
          'Thousands(1000)': x && x.cashCount && x.cashCount[1] && x.cashCount[1].coinCount,
          'FiveHundreds(500)': x && x.cashCount && x.cashCount[2] && x.cashCount[2].coinCount,
          'Hundreds(100)': x && x.cashCount && x.cashCount[3] && x.cashCount[3].coinCount,
          'Fifties(50)': x && x.cashCount && x.cashCount[4] && x.cashCount[4].coinCount,
          'Twenties(20)': x && x.cashCount && x.cashCount[5] && x.cashCount[5].coinCount,
          //'Tens(10)': x && x.cashCount && x.cashCount[6] && x.cashCount[6].coinCount,
          // 'Fives(5)': x && x.cashCount && x.cashCount[7] && x.cashCount[7].coinCount,
          // 'Twos(2)': x && x.cashCount && x.cashCount[8] && x.cashCount[8].coinCount,
          // 'Ones(1)': x && x.cashCount && x.cashCount[9] && x.cashCount[9].coinCount,
          'Remaining': x && x.remainingValue
        }
        res.push(vr);

      });

      var vr = {
        'Reg No': "Total",
        'Supplier Name': "",
        'Amount(Rs)': prevTotalAmount,
        'FiveThousands(5000)': coinTotal && coinTotal[0] && coinTotal[0].coinCount,
        'Thousands(1000)': coinTotal && coinTotal[1] && coinTotal[1].coinCount,
        'FiveHundreds(500)': coinTotal && coinTotal[2] && coinTotal[2].coinCount,
        'Hundreds(100)': coinTotal && coinTotal[3] && coinTotal[3].coinCount,
        'Fifties(50)': coinTotal && coinTotal[4] && coinTotal[4].coinCount,
        'Twenties(20)': coinTotal && coinTotal[5] && coinTotal[5].coinCount,
        //'Tens(10)': coinTotal && coinTotal[6] && coinTotal[6].coinCount,
        // 'Fives(5)': coinTotal && coinTotal[7] && coinTotal[7].coinCount,
        // 'Twos(2)': coinTotal && coinTotal[8] && coinTotal[8].coinCount,
        // 'Ones(1)': coinTotal && coinTotal[9] && coinTotal[9].coinCount,
        'Remaining': remainingValueTotal
      }
      res.push(vr);

      res.push({});

      var vr = {
        'Reg No': 'Group :' + selectedSearchValues.groupName,
        'Supplier Name': 'Factory :' + selectedSearchValues.factoryName
      }
      res.push(vr);

      const month = selectedDate.getMonth() + 1;
      const year = selectedDate.getFullYear();
      const monthYearString = `${month}/${year}`;
      var vr = {
        'Reg No': selectedSearchValues.routeName == undefined ? 'Route :' + 'All Routes' : 'Route :' + selectedSearchValues.routeName,
        'Supplier Name': 'Year and Month :' + monthYearString,
      }
      res.push(vr);
    }
    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(cashCountList);
    var settings = {
      sheetName: 'Denomination Report',
      fileName: 'Denomination Report ' + selectedSearchValues.factoryName + '-' + selectedSearchValues.routeName + '-'
        + ((denominationdetails.year === '' ? moment(new Date()).format('YYYY') : denominationdetails.year) - 1) + '/' + (denominationdetails.month === '' ? moment(new Date()).format('MMM') : selectedSearchValues.monthName) + '-'
        + (denominationdetails.year === '' ? moment(new Date()).format('YYYY') : denominationdetails.year) + '/' + (denominationdetails.month === '' ? moment(new Date()).format('MMM') : selectedSearchValues.monthName),
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = [];
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Denomination Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }
  function getSelectedDropdownValuesForReport(searchForm) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      factoryName: FactoryList[searchForm.factoryID],
      routeName: routes[searchForm.routeID],
      year: searchForm.year,
      groupName: GroupList[searchForm.groupID]
    })
  }

  function calculateCashCount(registrationList, cash) {
    const coinNames = {
      5000: 'fiveThousand',
      1000: 'oneThousand',
      500: 'fiveHundred',
      100: 'oneHundred',
      50: 'fifty',
      20: 'twenty',
      //10: 'ten',
      // 5: 'five',
      // 2: 'two',
      // 1: 'one'
    };

    const cashCountList = registrationList.map((registration) => {
      let amount = registration.amount;
      let cashCount = [];
      let coinTotal = {};

      const evaluationNote = 50;
      const dividerNote = 20;

      let remainingValue = 0;
      let numberOfCoins = 0;

      for (let index = 0; index < cash.length; index++) {

        if (parseInt(cash[index]) === evaluationNote) {
          const reminderEvaluation = amount % dividerNote;
          if (reminderEvaluation == 0) {
            remainingValue = amount % dividerNote;
            numberOfCoins = 0;
          } else {
            numberOfCoins = Math.trunc(amount / cash[index]);
          }
        } else {
          numberOfCoins = Math.trunc(amount / cash[index]);
        }

        cashCount.push({
          coinNumber: cash[index],
          coinCount: numberOfCoins,
        });

        if (numberOfCoins === 0) {
          continue;
        }

        let totDeduction = numberOfCoins * cash[index];
        amount -= totDeduction;

        if (coinTotal[coinNames[cash[index]]]) {
          coinTotal[coinNames[cash[index]]] += numberOfCoins;
        } else {
          coinTotal[coinNames[cash[index]]] = numberOfCoins;
        }
      }

      remainingValue = amount;

      return {
        supplierName: registration.firstName,
        amount: registration.amount,
        registrationNumber: registration.registrationNumber,
        cashCount: cashCount,
        remainingValue: remainingValue,
        coinTotal: coinTotal,
      };
    });

    let coinTotal = {};
    for (let i = 0; i < cashCountList.length; i++) {
      let cashCountObj = cashCountList[i];
      let cashCountArr = cashCountObj.cashCount;
      for (let j = 0; j < cashCountArr.length; j++) {
        let coinNumber = cashCountArr[j].coinNumber;
        let coinCount = cashCountArr[j].coinCount;
        if (coinTotal[coinNames[coinNumber]]) {
          coinTotal[coinNames[coinNumber]] += coinCount;
        } else {
          coinTotal[coinNames[coinNumber]] = coinCount;
        }
      }
    }
    const coinTotalArray = Object.entries(coinTotal).map(([coinValue, coinCount]) => ({
      coinName: coinNames[coinValue],
      coinCount: coinCount,
    }));
    const totalRemainingValue = cashCountList.reduce((total, cashCountObj) => {
      return total + parseInt(cashCountObj.remainingValue);
    }, 0);

    setRemainingValueTotal(totalRemainingValue);
    setCoinTotal(coinTotalArray);
    setCashCountList(cashCountList);
  };

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  async function GetDenominationSummaryReport() {
    const denominationData = await GetDenominationDetailsList();

    if (denominationData.statusCode == "Success" && denominationData.data != null) {
      if (denominationData.data.length == 0) {
        alert.error("No records to display");
        return;
      }
      const coinNames = [
        { coinValue: 5000, coinCount: 0 },
        { coinValue: 1000, coinCount: 0 },
        { coinValue: 500, coinCount: 0 },
        { coinValue: 100, coinCount: 0 },
        { coinValue: 50, coinCount: 0 },
        { coinValue: 20, coinCount: 0 },
        //{ coinValue: 10, coinCount: 0 },
        // { coinValue: 5, coinCount: 0 },
        // { coinValue: 2, coinCount: 0 },
        // { coinValue: 1, coinCount: 0 },
      ];

      var count = 0;

      denominationData.data.forEach(element => {
        let tempAmount = element.amount;
        coinNames.forEach(object => {
          const x = object.coinValue;
          if (tempAmount == 0) {
            return;
          }

          count = Math.floor(tempAmount / x);

          if (x === 50) {
            const reminderEvaluation = tempAmount % 20;
            if (reminderEvaluation === 0) {
              object.coinCount = 0;
              count = 0;
            } else {
              count = Math.floor(tempAmount / x);
            }
          }

          object.coinCount += count
          tempAmount -= (count * x)
        })
      });
      CreateDenominationSummaryFile(coinNames)

    }
    else {
      alert.error(denominationData.message);
    }
  }


  async function CreateDenominationSummaryFile(summaryDataList) {

    var basicDetails = {
      factoryName: FactoryList[denominationdetails.factoryID],
      routeName: routes[denominationdetails.routeID],
      groupName: GroupList[denominationdetails.groupID]
    }
    var file = await CreateDataForDenominationSummaryExcel(summaryDataList, basicDetails);
    var settings = {
      sheetName: 'Denomination Summary Report',
      fileName: 'Denomination Summary Report ' + basicDetails.factoryName + '-' + basicDetails.routeName + '-'
        + ((denominationdetails.year === '' ? moment(new Date()).format('YYYY') : denominationdetails.year) - 1) + '/' + (denominationdetails.month === '' ? moment(new Date()).format('MMM') : selectedSearchValues.monthName) + '-'
        + (denominationdetails.year === '' ? moment(new Date()).format('YYYY') : denominationdetails.year) + '/' + (denominationdetails.month === '' ? moment(new Date()).format('MMM') : selectedSearchValues.monthName),
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = [];
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Denomination Summary Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  async function CreateDataForDenominationSummaryExcel(array, basicDetails) {
    var res = [];
    if (array != null) {
      array.map(x => {
        var vr = {
          'Coin Value': x && x.coinValue,
          'Coin Count': x && x.coinCount
        }
        res.push(vr);

      });

      res.push({});

      var vr = {
        'Coin Value': 'Group :' + basicDetails.groupName,
        'Coin Count': 'Factory :' + basicDetails.factoryName
      }

      res.push(vr);

      const month = selectedDate.getMonth() + 1;
      const year = selectedDate.getFullYear();
      const monthYearString = `${month}/${year}`;
      var vr = {
        'Coin Value': basicDetails.routeName == undefined ? 'Route :' + 'All Route' : 'Route :' + basicDetails.routeName,
        'Coin Count': 'Year and Month :' + monthYearString,
      }
      res.push(vr);
    }
    return res;
  }

  const getPageMargins = () => {
    return `@media print {
      @page {
          size: A4 Protrait ;
          background-color: white !important;
          padding:2px
      }
 
      body {
          size: A4 Protrait ;
          background-color: white !important;
      }
  }`;
  }

  async function GetLastBalancePaymentExecutionDetails() {
    let response = await services.GetLastBalancePaymentExecutionDetails(denominationdetails.groupID, denominationdetails.factoryID);
    if (response.statusCode === 'Success' && response.data != null) {
      let { applicableYear, applicableMonth } = response.data;
      let date = new Date(Number(applicableYear), Number(applicableMonth) - 1);
      setLastBalancePaymentRunDate(date);
    }
  }

  const handleLimitChange = (event) => {
    setLimit(event.target.value);
  };
  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: denominationdetails.groupID,
              factoryID: denominationdetails.factoryID,
              routeID: denominationdetails.routeID,
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
                // routeID: Yup.number().required('Route is required').min("1", 'Route is required')
              })
            }
            onSubmit={() => trackPromise(GetDenominationDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={denominationdetails.groupID}
                              variant="outlined"
                              id="groupID"
                              size='small'
                              disabled={!permissionList.isGroupFilterEnabled}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={denominationdetails.factoryID}
                              variant="outlined"
                              id="factoryID"
                              size='small'
                              disabled={!permissionList.isFactoryFilterEnabled}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.routeID && errors.routeID)}
                              fullWidth
                              helperText={touched.routeID && errors.routeID}
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={denominationdetails.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routes)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                helperText="Select applicable month"
                                value={selectedDate}
                                onChange={(date) => handleDateChange(date)}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1050}>
                        {cashCountList.length > 0 ?
                          <TableContainer>
                            <Table aria-label="caption table" size='small'>
                              <TableHead>
                                <TableRow>
                                  {columnTitles.map((title, index) => (
                                    <TableCell key={title} align={index === 0 ? "left" : index === 1 ? "left" : "right"} style={{ border: '1px solid #ccc' }}>{index !== 0 && index !== 1 && index !== 2 && index !== columnTitles.length - 1 ? `Rs. ${title}` : title}</TableCell>
                                  ))}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {cashCountList.slice(page * limit, page * limit + limit).map((data, index) => (
                                  <TableRow key={index}>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                    >
                                      {data.registrationNumber}
                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                    >
                                      {data.supplierName}
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                    >
                                      {data.amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                    {data.cashCount.map((coin, index) => (
                                      <TableCell key={cash[index]} align='right' component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                      >
                                        {coin.coinCount}
                                      </TableCell>
                                    ))}
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                    >
                                      {data.remainingValue}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                              <TableRow>
                                <TableCell align={'left'} style={{ border: '1px solid #ccc' }}><b>Total</b></TableCell>
                                <TableCell align={'left'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                >
                                </TableCell>
                                <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                >
                                  <b>{prevTotalAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</b>
                                </TableCell>
                                {coinTotal.map((coin, index) => (
                                  <TableCell key={cash[index]} align='right' component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                  >
                                    <b>{coin.coinCount}</b>
                                  </TableCell>
                                ))}
                                <TableCell align={'right'} component="th" scope="row" style={{ border: '1px solid #ccc' }}
                                >
                                  <b>{remainingValueTotal}</b>
                                </TableCell>
                              </TableRow>
                            </Table>
                            <TablePagination
                              component="div"
                              count={denominationCropData.length}
                              onChangePage={handlePageChange}
                              onChangeRowsPerPage={handleLimitChange}
                              page={page}
                              rowsPerPage={limit}
                              rowsPerPageOptions={[5, 10, 25]}
                            />
                          </TableContainer>
                          : null
                        }
                      </Box>
                      <br />
                    </PerfectScrollbar>
                    <Divider />
                    {denominationCropData.length > 0 ?
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <Button
                          color="primary"
                          variant="contained"
                          type="button"
                          style={{ marginRight: "1rem" }}
                          size='small'
                          onClick={() => trackPromise(GetDenominationSummaryReport())}
                        >
                          Denomination Summary
                        </Button>
                        <Button
                          color="primary"
                          id="btnRecord"
                          // type="submit"
                          variant="contained"
                          style={{ marginRight: '1rem' }}
                          className={classes.colorRecord}
                          onClick={() => createFile()}
                          size='small'
                        >
                          EXCEL
                        </Button>
                        <ReactToPrint
                          documentTitle={"Denomination Report"}
                          trigger={() => <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorCancel}
                            size='small'
                          >
                            PDF
                          </Button>}
                          pageStyle={getPageMargins()}
                          content={() => componentRef.current}
                        />
                        <div hidden={true}>
                          <CreatePDF ref={componentRef}
                            cashCountList={cashCountList} coinTotal={coinTotal} remainingValueTotal={remainingValueTotal}
                            selectedSearchValues={selectedSearchValues} selectedDate={selectedDate} searchDate={denominationdetails} prevTotalAmount={prevTotalAmount}
                            coinNames={cash} columnTitles={columnTitles}
                          />
                        </div>
                      </Box> : null}

                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
